// Mocks for /api/secure/me/activities/*

import { delay } from './index'

const STORAGE_KEY = 'patientPortal.mock.activities.v1'

function seedFor(profile) {
  if (!profile) return { assignments: [], completions: [] }
  const isSelf = profile.relation === 'SELF'
  const assignments = isSelf
    ? [
        {
          id: 'act_journal',
          title: 'Evening journal: 3 things',
          description:
            'Three things you noticed today — small or big. Practice noticing rather than judging.',
          estimatedDurationMinutes: 5,
          frequency: 'Daily',
          prescribedBy: 'Dr. Meera Iyer',
          contentRef: null,
          isActive: true,
        },
        {
          id: 'act_walk',
          title: '20-minute outdoor walk',
          description: 'Lights out + bright morning walk for circadian alignment.',
          estimatedDurationMinutes: 20,
          frequency: 'Daily',
          prescribedBy: 'Dr. Neha Bose',
          contentRef: null,
          isActive: true,
        },
      ]
    : [
        {
          id: 'act_physio',
          title: 'Knee strengthening — set of 3',
          description: 'Quad sets, straight-leg raises, mini-squats. 10 reps × 3 sets.',
          estimatedDurationMinutes: 15,
          frequency: '3x/week',
          prescribedBy: 'Physio Anjali',
          contentRef: null,
          isActive: true,
        },
      ]
  return { assignments, completions: [] }
}

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (e) {
    return {}
  }
}
function writeStore(s) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s))
  } catch (e) {
    /* ignore */
  }
}
function ensure(profile) {
  const store = readStore()
  if (!store[profile.id]) {
    store[profile.id] = seedFor(profile)
    writeStore(store)
  }
  return { store, prof: store[profile.id] }
}

function todayBounds() {
  const start = new Date()
  start.setHours(0, 0, 0, 0)
  const end = new Date(start)
  end.setDate(end.getDate() + 1)
  return [start.getTime(), end.getTime()]
}

export async function listActive(profile) {
  await delay()
  if (!profile) return []
  const { prof } = ensure(profile)
  const [s, e] = todayBounds()
  return prof.assignments
    .filter((a) => a.isActive)
    .map((a) => {
      const completionsToday = prof.completions
        .filter((c) => c.assignmentId === a.id)
        .filter((c) => {
          const t = Date.parse(c.completedAt || 0)
          return t >= s && t < e
        })
      return {
        ...a,
        completedToday: completionsToday.length > 0,
        lastCompletedAt: prof.completions
          .filter((c) => c.assignmentId === a.id)
          .map((c) => c.completedAt)
          .sort()
          .reverse()[0] || null,
      }
    })
}

export async function complete(profile, assignmentId, body) {
  await delay()
  if (!profile) return null
  const { store, prof } = ensure(profile)
  const c = {
    id: `comp_${Date.now()}`,
    assignmentId,
    completedAt: body?.completedAt || new Date().toISOString(),
    note: body?.note || null,
    ratingByPatient: body?.ratingByPatient || null,
  }
  prof.completions.push(c)
  store[profile.id] = prof
  writeStore(store)
  return c
}

export async function history(profile, assignmentId) {
  await delay()
  if (!profile) return []
  const { prof } = ensure(profile)
  return prof.completions
    .filter((c) => c.assignmentId === assignmentId)
    .sort((a, b) => (b.completedAt || '').localeCompare(a.completedAt || ''))
}

export function __resetActivitiesMock() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}
